import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get(`${API}/projects`).then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="projects-page" className="pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400 mb-6">
            Nos Actions
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-50 mb-8 max-w-4xl leading-[1.1]">
            Des projets concrets, des resultats mesurables
          </h1>
          <p className="font-body text-base md:text-lg font-light text-slate-300 max-w-3xl">
            Chaque projet EDUCPEOPLE est concu pour repondre a un besoin identifie sur le terrain, avec des objectifs clairs et des indicateurs de succes mesurables.
          </p>
        </div>
      </section>

      <div className="section-divider" />

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-16">
          {projects.map((project, i) => (
            <Link
              key={project.slug}
              to={`/projets/${project.slug}`}
              data-testid={`project-link-${project.slug}`}
              className={`group grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
                i % 2 === 1 ? "lg:direction-rtl" : ""
              }`}
            >
              <div className={`relative rounded-3xl overflow-hidden border border-white/10 group-hover:border-blue-500/30 transition-colors ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <img
                  src={project.image_url}
                  alt={project.title}
                  className="w-full h-72 object-cover img-zoom opacity-70 group-hover:opacity-90 transition-opacity"
                />
              </div>
              <div className={`${i % 2 === 1 ? "lg:order-1 lg:text-right" : ""}`}>
                <h2 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-4 group-hover:text-blue-400 transition-colors">
                  {project.title}
                </h2>
                <p className="font-body text-base text-slate-400 leading-relaxed mb-4">
                  {project.context}
                </p>
                <div className={`flex flex-wrap gap-2 mb-6 ${i % 2 === 1 ? "lg:justify-end" : ""}`}>
                  {(project.kpis || []).map((kpi, k) => (
                    <span key={k} className="font-body text-xs bg-blue-500/10 text-blue-400 px-3 py-1 rounded-full">
                      {kpi}
                    </span>
                  ))}
                </div>
                <span className={`inline-flex items-center gap-2 text-blue-400 font-body text-sm font-medium ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
                  Voir le projet <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
